module.exports = __webpack_public_path__ + "img/serviceCheck.1336fb8a.png";